import axios from 'axios';
import { baseURL } from '@/utils/baseUrl';

axios.defaults.headers.Authorization = `Bearer ${localStorage.getItem('accessToken')}`;

axios.defaults.headers['X-Locale'] = window.location.pathname.split('/')[1];

export default axios.create({
  baseURL,
});
